// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".createNewJobPopoverContent_root__1HEoR {\n  padding: 20px;\n  box-sizing: border-box; }\n  .createNewJobPopoverContent_root__1HEoR .createNewJobPopoverContent_title__19ilm {\n    font-style: normal;\n    font-weight: 600;\n    font-size: 14px;\n    line-height: 14px;\n    color: #333333; }\n  .createNewJobPopoverContent_root__1HEoR .createNewJobPopoverContent_text__2j9el {\n    font-style: normal;\n    font-weight: 500;\n    font-size: 11px;\n    line-height: 16px;\n    color: #686868; }\n  .createNewJobPopoverContent_root__1HEoR .createNewJobPopoverContent_bold__3SJ6H {\n    font-weight: bold;\n    margin-left: 5px;\n    margin-right: 4px; }\n", ""]);
// Exports
exports.locals = {
	"root": "createNewJobPopoverContent_root__1HEoR",
	"title": "createNewJobPopoverContent_title__19ilm",
	"text": "createNewJobPopoverContent_text__2j9el",
	"bold": "createNewJobPopoverContent_bold__3SJ6H"
};
module.exports = exports;
